// component
import SvgColor from '../../../components/svg-color';
import { useRole } from '../../../hooks/useRole';

// ----------------------------------------------------------------------

const icon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const useNavConfig = () => {
	const { isAdmin, isUser, isStaff, isContractor } = useRole();

	const menuItems = [
		{
			title: 'profile',
			path: '/dashboard/user-profile',
			icon: icon('ic_user'),
		},
		{
			title: 'Single Request',
			path: '/dashboard/requests',
			icon: icon('ic_request'),
		},
	];

	if (isAdmin || isUser || isStaff || isContractor) {
		menuItems.push({
			title: 'Bulk Request',
			path: '/dashboard/bulk-requests',
			icon: icon('ic_bulk_request'),
		});
	}

	if (isAdmin) {
		menuItems.push({
			title: 'Admin',
			path: '/dashboard/admin',
			icon: icon('ic_lock'),
		});
	}

	return menuItems;
};

export default useNavConfig;
